import React from "react";
import styles from "./ProgessBar.module.scss";

const ProgressBar = ({ percentage, status }) => {
    console.log("ProgressBar render:", { percentage, status });
    console.log("Styles object:", styles);

    const getProgressColor = (status) => {
        switch (status) {
            case "Completed":
                return "#27ae60";
            case "In Transit":
                return "#3498db";
            case "Paused":
                return "#f39c12";
            default:
                return "#e0e0e0";
        }
    };

    return (
        <div className={styles.progressContainer}>
            <div className={styles.progressBar}>
                <div
                    className={styles.progressFill}
                    style={{
                        width: `${percentage || 0}%`,
                        backgroundColor: getProgressColor(status),
                    }}
                >
                    <p>x</p>
                </div>
            </div>
            <span className={styles.progressText}>{percentage || 0}%</span>
        </div>
    );
};

export default ProgressBar;
